import React, { useEffect, useState } from "react";
import "../Styles/Industries.css";
import "../Styles/ContactSection.css";
import Footer from "./Footer";
import industry1 from "../Images/industry1.jpg";
import industry2 from "../Images/industry2.jpg";
import industry3 from "../Images/industry3.jpg";
import industry4 from "../Images/industry4.jpg";
import industry5 from "../Images/industry5.jpg";
import industry6 from "../Images/industry6.jpg";

const industries = [
  { img: industry1, alt: "Valve and Pump", title: "Valve and Pump Manufacturer" },
  { img: industry2, alt: "Wire and Cable", title: "Wire and Cable Extrusion" },
  { img: industry3, alt: "Oil and Gas", title: "Oil and Gas Industries" },
  { img: industry4, alt: "Agricultural Equipment", title: "Agricultural Equipment Manufacturer" },
  { img: industry5, alt: "Heavy Machinery", title: "Heavy Machinery Components" },
  { img: industry6, alt: "Automotive", title: "Automotive Components Manufacturer" },
];

function ContactSection() {
  return (
    <div className="contact-us">
      <div className="contact-us-inner">
        <div className="contact-us-left">
          <p className="contact-us-eyebrow">Get In Touch</p>
          <h2 className="contact-us-heading">Let's build something<br />precise together.</h2>
          <div className="contact-us-items">
            <div className="contact-us-item">
              <span className="contact-us-icon">📍</span>
              <div>
                <span className="contact-us-label">Address</span>
                <span className="contact-us-value">6240 Hawthorne Drive, Windsor, ON N8T 1J9, Canada</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">📞</span>
              <div>
                <span className="contact-us-label">Phone</span>
                <span className="contact-us-value">+1 519 800-8080</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">✉️</span>
              <div>
                <span className="contact-us-label">Email</span>
                <a href="mailto:info@precisionworks.ca" className="contact-us-value contact-us-link">info@precisionworks.ca</a>
              </div>
            </div>
          </div>
          <a href="/contact" className="contact-us-cta">Send Us a Message</a>
        </div>
        <div className="contact-us-map">
          <iframe
            title="Google Maps Locator"
            src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=6240+Hawthorne+Dr,+Windsor,+ON+N8T+1J9,+Canada&t=&z=16&ie=UTF8&iwloc=B&output=embed"
            style={{ width: "100%", height: "100%", border: 0, display: "block" }}
          ></iframe>
        </div>
      </div>
    </div>
  );
}

function Industries() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setLoaded(true); }, []);

  return (
    <div className="industries-page">
      <div className="page-hero">
        <h1>INDUSTRIES WE SERVE</h1>
        <div className="section-divider"></div>
      </div>

      <div className="industries-grid-section" style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.8s ease" }}>
        <div className="industries-grid">
          {industries.map((ind) => (
            <div className="industry-card" key={ind.title}>
              <img src={ind.img} alt={ind.alt} />
              <div className="industry-card-overlay">
                <h2>{ind.title}</h2>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ContactSection />
      <Footer />
    </div>
  );
}

export default Industries;
